/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import Cookies from 'js-cookie';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * API service for Assignment Submit component.
 */
@Injectable({
  providedIn: 'root',
})
export class AssignmentSubmitUploadHttpService {
  constructor(
    private http: HttpClient,
  ) { }

  /**
   * Submits the current assigment.
   */
  submit(unitId: string) {
    return this.http
      .post(
        `assignment/submit?unitId=${unitId}`,
        {},
      )
      .toPromise();
  }

  /**
   * Unsubmits the current assigment.
   */
  unsubmitAssignment(unitId: string) {
    return this.http
      .post(
        `assignment/unsubmit?unitId=${unitId}`,
        {},
      )
      .toPromise();
  }
}
